function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PROFILE_UPDATE_DISCLAIMER_VISIBILITY, SET_PROGRESS_BAR_ON_CLICK_ACTION, PROFILE_INIT_PAGES, PROFILE_UPDATE_PAGE, PROFILE_TOGGLE_SHOW_ALL_PAGE, PROFILE_NEXT_PAGE, PROFILE_LAST_PAGE, PROFILE_JUMP_TO_PAGE, PROFILE_SET_PAGE_VISITED } from "../actions/actionTypes";
var getProgressBarSteps = function getProgressBarSteps(state, fct) {
  var barProps = [];
  for (var p in state.pages) {
    barProps.push({
      stepKey: p,
      stepLabel: state.pages[p].pageLabel,
      completed: state.pages[p].completed
    });
  }
  return barProps;
};
var updatePage = function updatePage(state) {
  var newState = _objectSpread({}, state);
  var steps = getProgressBarSteps(newState);
  return _objectSpread(_objectSpread({}, newState), {}, {
    progressBarProps: _objectSpread(_objectSpread({}, newState.progressBarProps), {}, {
      showCompletedIcon: state.showCompletedIcon,
      currentStep: newState.currentPage,
      steps: steps
    })
  });
};
var updateProgressBarOnClickAction = function updateProgressBarOnClickAction(state, resp) {
  var fct = resp.fct;
  var newState = _objectSpread({}, state);
  var newBarProps = getProgressBarSteps(newState, fct);
  return _objectSpread(_objectSpread({}, newState), {}, {
    progressBarProps: _objectSpread(_objectSpread({}, newState.progressBarProps), {}, {
      onClickAction: fct,
      steps: getProgressBarSteps(newState)
    })
  });
};
var updateWindowHash = function updateWindowHash(hash) {
  hash.replace(/\W/g, '');
  window.location.hash = hash;
};
var defaultState = {
  currentPage: null
};
export default function pageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var resp = arguments.length > 1 ? arguments[1] : undefined;
  var newState = {};
  var type = resp.type,
    value = resp.value;
  switch (type) {
    case PROFILE_UPDATE_DISCLAIMER_VISIBILITY:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        showDisclaimer: value ? value.visibility : false
      });
      break;
    case PROFILE_TOGGLE_SHOW_ALL_PAGE:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        showAllPage: value ? value.showAllPage : !state.showAllPage
      });
    case PROFILE_INIT_PAGES:
      /* //we do this in updatePage already.
      let progressBarProps = {
      currentStep: newState.currentPage,
      showCompletedIcon: state.showCompletedIcon,
      steps: getProgressBarSteps(newState)
      };
      newState = {
      ...state,
      progressBarProps
      };*/
      break;
    case PROFILE_UPDATE_PAGE:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        currentPage: value.currentPage
      });
      break;
    case PROFILE_NEXT_PAGE:
      var nextPage = state.pages[value.currentPage].nextPage;
      updateWindowHash(nextPage);
      newState = _objectSpread(_objectSpread({}, state), {}, {
        currentPage: nextPage
      });
      break;
    case PROFILE_LAST_PAGE:
      var lastPage = state.pages[value.currentPage].lastPage;
      updateWindowHash(lastPage);
      newState = _objectSpread(_objectSpread({}, state), {}, {
        currentPage: lastPage
      });
      break;
    case PROFILE_JUMP_TO_PAGE:
      window.history.pushState('', value.currentPage, window.location.pathname);
      updateWindowHash(value.currentPage);
      newState = _objectSpread(_objectSpread({}, state), {}, {
        currentPage: value.currentPage,
        transitionType: value.transitionType
      });
      break;
    case SET_PROGRESS_BAR_ON_CLICK_ACTION:
      return updateProgressBarOnClickAction(_objectSpread({}, state), value.onClick);
    case PROFILE_SET_PAGE_VISITED:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        pages: _objectSpread({}, state.pages)
      });
      if (value.pageName !== 'Finished') {
        newState.pages = _objectSpread(_objectSpread({}, state.pages), {}, _defineProperty({}, value.pageName, _objectSpread(_objectSpread({}, state.pages[value.pageName]), {}, {
          visited: value.visited
        })));
      }
      break;
    default:
      newState = state;
      break;
  }
  newState = updatePage(newState);
  return newState;
}